<template>
  <div class="rule-page">
    <section class="rule-card">
      <div class="rule-header">
        <span class="rule-icon">
          <i class="fas fa-book"></i>
        </span>
        <div>
          <h1 class="rule-title">
            {{
              $store.state.language === "en"
                ? "Rules And Regulations"
                : "စည်းကမ်းချက်များ"
            }}
          </h1>
          <p class="rule-subtitle">
            {{
              $store.state.language === "en"
                ? "Please read carefully before continuing"
                : "ဆက်လက်မီ စည်းကမ်းချက်များကို သေချာဖတ်ရှုပါ"
            }}
          </p>
        </div>
      </div>

      <ol class="rule-list">
        <li>
          <span class="rule-num">(၁)</span>
          <div>
            ဘော်ဒီ ၊ ဂိုးပေါင်း ၊ စုံမ ပွဲစဉ်များကို (⭐) ဖြင့် ပွဲကြီး / ပွဲသေး
            ခွဲခြားထားပြီး
            <div class="rule-detail">
              <span
                >ပွဲကြီး အကောက် -
                <strong class="highlight">5%</strong> ( ၁၀၀၀ ယူနစ်မှ သိန်း ၁၀၀
                ယူနစ် အထိ )</span
              >
              <span
                >ပွဲသေး အကောက် -
                <strong class="highlight">5%</strong> ( ၁၀၀၀ ယူနစ်မှ ၁၀ သိန်း
                ယူနစ်အထိ )</span
              >
              <span>ဆော့ကစားနိုင်ပါသည်။</span>
            </div>
          </div>
        </li>
        <li>
          <span class="rule-num">(၂)</span>
          <div>
            မောင်းများကို အနည်းဆုံး ၂ ပွဲမှ ၁၂ ပွဲအထိ ဆော့ကစားနိုင်ပြီး ၊
            မောင်းတစ်ရွက်လျှင် ၅၀၀ ယူနစ်မှ ၂ သိန်း ယူနစ်အထိ ဆော့ကစားနိုင်ပါသည်။
            ( ပွဲမလာ ၊ ပွဲပျက် ၊ PP ပွဲများပါခဲ့လျှင် ကျန်ပွဲဖြင့်
            အလျော်အစားပြုလုပ်ပါမည်။ )
          </div>
        </li>
        <li>
          <span class="rule-num">(၃)</span>
          <div>
            ၂သင်းမှ ၈သင်းထိ အကောက် -
            <strong class="highlight">16%</strong> နှင့် ၉ သင်း နှင့်အထက် -
            <strong class="highlight">20%</strong> ကောက်ခံပါမည်။
          </div>
        </li>
        <li>
          <span class="rule-num">(၄)</span>
          <div>
            ရွေးချယ်ထားသောမောင်းများမှ ပွဲစဉ်များအားလုံး မကန်ဖြစ်မှသာ
            လောင်းကြေးငွေအား ပြန်လည်ရရှိမည် ဖြစ်ပါသည်။
          </div>
        </li>
        <li>
          <span class="rule-num">(၅)</span>
          <div>
            သတ်မှတ်ရက်အတွင်း နောက်တစ်နေ့ 10:30am အတွင်း result
            (ပွဲစဉ်မပြီးသော) မထွက်သေးသောပွဲစဉ်များအား အလျော်အစား ပြုလုပ်ပေး
            မည်မဟုတ်ပါ။
          </div>
        </li>
        <li>
          <span class="rule-num">(၆)</span>
          <div>
            ဂိုးရလာဒ်များကို မြန်မာကြေးထွက်ရှိသော Betting company
            (ibet789,bet365,sportbook365) များမှထွက်ရှိသောရလာဒ်များ
            ဖြင့်သာ အလျော်အစားပြုလုပ်ပြီး အဆိုပါကုမ္မဏီများမှ 9:00am အထိ
            မထွက်ရှိပါက flashscore..com, livescore..com တို့အား
            ကြည့်ရှူပြီး မတွေ့ရှိပါက သက်ဆိုင်ရာအဖွဲ့ချုပ်၏
            ရလာဒ်များကိုသာအတည်ပြုပါသည်။
          </div>
        </li>
        <li>
          <span class="rule-num">(၇)</span>
          <div>
            ဂိုးရလာဒ်များထည့်သွင်းရာတွင်အချို့ပွဲစဥ်များသည် ညပိုင်းတွင်ရလာဒ်တစ်မျိုးထွက်ပေါ်ပြီး
            မနက်ပိုင်းတွင်ရလာဒ်တစ်မျိုးဖြင့်
            ပြင်ဆင်ပြောင်းလဲထွက်ပေါ်လာပါက နေ့ခင်း ၁၂
            နာရီအထိသာပေးပို့အကြောင်းကြားလာသည့်ဘောင်ချာများကိုသာပြင်ဆင်ပြောင်းလဲ
            ပေးပါမည်။
          </div>
        </li>
        <li>
          <span class="rule-num">(၈)</span>
          <div>
            အချိန်စောကန်သွားသော ပွဲစဥ်များရှိပါက အခြား Betting company
            များနည်းတူမဟုတ်ပဲ Bagan Moung တွင်မူလအချိန်အတိုင်း ဖွင့်လှစ်ထားမိပါက
            အဆိုပါပွဲများအား Cancel match ပြုလုပ်ပါမည်။အချိန်ပြောင်းလဲထားပါက
            အလျော်အစားပြုလုပ်ပါမည်။
          </div>
        </li>
        <li>
          <span class="rule-num">(၉)</span>
          <div>
            ပုံမှန်မဟုတ်သော ပွဲစဥ်များ ပါရှိပါက ၄င်းပွဲစဥ်များအား
            အလျော်အစားမပြုလုပ်ပဲ Cancel Match ပြုလုပ်ပြီး လောင်းကြေးငွေ
            ပြန်အမ်း ပေးပါမည်။
          </div>
        </li>
        <li>
          <span class="rule-num">(၁၀)</span>
          <div>
            သာမန်ကစားခြင်းမဟုတ်ပဲ ကြေးအဟ သီးသန့်ကြားထိုး ကစားပါက
            အဆိုပါ User ၏ကြားထိုး ကစားကြောင်းအား reject ပြုလုပ်ပါမည်။
          </div>
        </li>
        <li>
          <span class="rule-num">(၁၁)</span>
          <div>
            နည်းပညာချွတ်ယွင်း၍ အခြားသော Betting Company များနှင့်စျေးနှုန်း
            ပေါက်ကြေး များ (လွန်ကဲစွာ) ကွဲလွဲဖွင့်လှစ်မိပါက ယင်းစျေးနှုန်း
            ဖြင့် ကစားထားသော မောင်းနှင့်ဘော်ဒီများကို Cancel ပြုလုပ်ပြီး
            အရင်းငွေများကိုပြန်ပေးပါမည်။
          </div>
        </li>
        <li>
          <span class="rule-num">(၁၂)</span>
          <div>
            အငြင်းပွားဖွယ်ရာ ကိစ္စရပ်များပေါ်ပေါက်လာပါက အများနှင့်
            နှိုင်းယှဉ်သုံးသပ်ရသည့်အတွက် Bagan Moung ၏
            ဆုံးဖြတ်ချက်သာအတည်ဖြစ်ပါသည်။
          </div>
        </li>
      </ol>

      <p class="rule-note">
        စည်းကမ်းချက်များကို သေချာစွာဖတ်ရှုပြီး သဘောတူပါကြောင်း
        အတည်ပြုပေးပါ။
      </p>
    </section>

    <div class="rule-actions">
      <button
        type="button"
        class="reject-btn"
        @click="logout"
        :disabled="isLoggingOut"
      >
        <Loading v-if="isLoggingOut" size="18" color="#f5f5f5" />
        <template v-else>
          {{
            $store.state.language === "en" ? "Decline" : "အတည်မပြုပါ"
          }}
        </template>
      </button>
      <button type="button" class="accept-btn" @click="toHome">
        {{
          $store.state.language === "en" ? "I Agree" : "အတည်ပြုပါသည်"
        }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Loading } from "vant";

export default {
  components: { Loading },
  data() {
    return {
      isLoggingOut: false,
    };
  },
  methods: {
    ...mapActions(["logoutUser"]),
    async logout() {
      if (this.isLoggingOut) return;
      this.isLoggingOut = true;
      try {
        await this.logoutUser();
        this.$router.push("/welcome");
      } catch (error) {
        this.isLoggingOut = false;
      }
    },
    toHome() {
      this.$router.push("/home");
    },
  },
};
</script>

<style scoped>
.rule-page {
  min-height: 100vh;
  padding: 16px 14px 6.5rem;
  background: #0c0c0c;
  color: #f0e6c8;
}

.rule-card {
  max-width: 720px;
  margin: 0 auto;
  padding: 16px;
  border-radius: 16px;
  background: #1c1c1c;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.rule-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.rule-icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
  flex-shrink: 0;
}

.rule-icon i {
  font-size: 1rem;
}

.rule-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 800;
  color: #f0e6c8;
  line-height: 1.3;
}

.rule-subtitle {
  margin: 4px 0 0;
  font-size: 0.78rem;
  color: #b8b3a8;
}

.rule-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.rule-list li {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  font-size: 0.88rem;
  line-height: 1.65;
  color: #ece6d4;
  font-weight: 400;
}

.rule-num {
  flex-shrink: 0;
  min-width: 2.2rem;
  color: #e7b534;
  font-weight: 700;
}

.highlight {
  color: #f7d56a;
  font-weight: 700;
}

.rule-detail {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
  padding-left: 8px;
  border-left: 2px solid rgba(231, 181, 52, 0.35);
}

.rule-note {
  margin: 8px 0 0;
  padding: 12px;
  border-radius: 12px;
  background: rgba(231, 181, 52, 0.08);
  border: 1px solid rgba(231, 181, 52, 0.18);
  color: #f7d56a;
  font-size: 0.85rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.5;
}

.rule-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  gap: 10px;
  padding: 12px 14px calc(12px + env(safe-area-inset-bottom));
  background: #111;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.reject-btn,
.accept-btn {
  flex: 1;
  height: 2.7rem;
  border-radius: 12px;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
}

.reject-btn {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: #242424;
  color: #f0e6c8;
}

.accept-btn {
  border: 0;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
}
</style>
